<div
  tabindex="0"
  (click)="selectPicture()"
  (keydown.enter)="selectPicture()"
  class="picture-container display-flex flex-column grid-gap-4"
  [ngClass]="active ? 'active' : ''"
>
  <ng-container *ngIf="picture?.url" [ngSwitch]="picture.originalFileName | fileMimeType">
    <img
      *ngSwitchCase="FileMimeType.Image"
      [attr.src]="picture.url"
      [attr.alt]="picture.title"
      class="display-flex img-control"
    />
    <div *ngSwitchCase="FileMimeType.Video" [attr.alt]="picture.title" class="display-flex video-control">
      <div class="flex-1 display-flex justify-content-center align-items-center">
        <mat-icon class="video-control-play" [inline]="true">play_circle_outline</mat-icon>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="picture?.externalUrl" [ngSwitch]="picture.externalUrl | fileMimeType">
    <img
      *ngSwitchCase="FileMimeType.Image"
      [attr.src]="picture.externalUrl"
      [attr.alt]="picture.title"
      class="display-flex img-control"
    />
    <div *ngSwitchDefault [attr.alt]="picture.title" class="display-flex img-control">
      <div
        class="fade-truncate flex-1 display-flex justify-content-center align-items-center p-8"
        [matTooltip]="picture.externalUrl"
      >
        <a (click)="$event.stopPropagation()" href="{{ picture.externalUrl }}" target="_blank">{{
          picture.externalUrl
        }}</a>
      </div>
    </div>
  </ng-container>

  <img *ngIf="file" [attr.src]="file | fileToObjectUrl" [attr.alt]="file.name" class="display-flex img-control" />
  <button
    *ngIf="showDeleteButton"
    class="delete-btn button-icon-delete"
    mat-icon-button
    color="primary"
    [disabled]="lockDeleteButton"
    (click)="deleteItem()"
    [matTooltip]="'Delete'"
  >
    <app-icon [iconHeight]="24" [iconWidth]="24" [svg]="EIcon.TRASH" [iconColor]="EColorPalette.cRed2"></app-icon>
  </button>
  <ng-container
    *ngIf="showCommentSection"
    [ngTemplateOutlet]="editMode ? commentSectionEditTemplate : commentSectionReadTemplate"
  ></ng-container>
</div>

<ng-template #commentSectionReadTemplate>
  <ng-container [ngTemplateOutlet]="comment.value ? commentContentTemplate : commentAddTemplate"></ng-container>
</ng-template>

<ng-template #commentContentTemplate>
  <div
    class="comment-section body-small-italic"
    [matTooltip]="comment.value"
    tabindex="0"
    (click)="toggleEditMode(true)"
    (keydown.enter)="toggleEditMode(true)"
  >
    {{ comment.value | textMask: 50 }}
  </div>
  <button
    *ngIf="showCommentActionButtons"
    class="button-icon-delete ml-auto"
    mat-icon-button
    color="primary"
    (click)="toggleEditMode(true)"
    [matTooltip]="'Edit comment'"
    [disabled]="lockCommentActionButtons"
  >
    <app-icon [iconHeight]="24" [iconWidth]="24" [svg]="EIcon.EDIT" [iconColor]="EColorPalette.cGreen3"></app-icon>
  </button>
</ng-template>

<ng-template #commentAddTemplate>
  <button
    *ngIf="showCommentActionButtons"
    class="button-icon-delete ml-auto"
    mat-icon-button
    color="primary"
    (click)="toggleEditMode(true)"
    [matTooltip]="'Add Comment'"
    [disabled]="lockCommentActionButtons"
  >
    <app-icon [iconHeight]="24" [iconWidth]="24" [svg]="EIcon.PLUS" [iconColor]="EColorPalette.cGreen3"></app-icon>
  </button>
</ng-template>

<ng-template #commentSectionEditTemplate>
  <app-input-area
    [contentCss]="'display-flex flex-column'"
    [formControl]="comment"
    [attrPlaceholder]="'Type your comment'"
  ></app-input-area>
  <div class="display-flex grid-gap-4 ml-auto">
    <button
      class="button-icon-delete"
      mat-icon-button
      color="primary"
      (click)="save()"
      [matTooltip]="'Save'"
      [disabled]="lockCommentActionButtons || comment.invalid"
    >
      <app-icon
        [iconHeight]="24"
        [iconWidth]="24"
        [svg]="EIcon.SAVE"
        [iconColor]="lockCommentActionButtons || comment.invalid ? EColorPalette.cGray7 : EColorPalette.cRed2"
      ></app-icon>
    </button>
    <button
      class="button-icon-delete"
      mat-icon-button
      color="primary"
      (click)="cancel()"
      [matTooltip]="'Discard changes'"
      [disabled]="lockCommentActionButtons"
    >
      <app-icon [iconHeight]="24" [iconWidth]="24" [svg]="EIcon.CLOSE" [iconColor]="EColorPalette.cRed2"></app-icon>
    </button>
  </div>
</ng-template>
